const eventsData = [
    {
        id: 1,
        name: 'sociopreneurs',
        eventName : 'Sociopreneurs',
        description:'B-plan event to provide a platform to aspiring social entrepreneurs. It aims to encourage change-makers provide them mentorship from renowned experts.',        
        poster:'/images/socio_poster.jpeg',
        registration_link: 'http://nss.iitd.ac.in/l/register_SocioPreneurs',
        one_liner: 'A platform to motivate aspiring social entrepreneurs to develop their ideas and inspire them for social change',

        timeline : {
            'Registration Deadline': '13-March-2022',
            'Submission Deadline': '20-March-2021',
            'First Day of Kaizen' : '18-April-2022',
            'Inauguration Ceremony' : '18-April-2022 , 6:45pm - 8:45pm',
            'Event Date' : '19-April-2022, 2pm - 4pm',
        },
        color : 'aquamarine',
        prizes : {
            'Winner' : {
                'id' : 1,
                'Award' : 'Rs. 5000 + Discount Coupons from GeeksforGeeks worth Rs. 2000 + certificate'
            },
            '1st Runner Up' : {
                'id' : 2,
                'Award' : 'Rs. 3000 + Discount Coupons from GeeksforGeeks worth Rs. 1500 + certificate'
            },
            '2nd Runner Up' : {
                'id' : 3,
                'Award' : 'Rs. 2000 + Discount Coupons from GeeksforGeeks worth Rs. 1000 + certificate'
            },
            'Participants' : {
                'id' : '',
                'Award' : 'Participation certificate'
            }
        },
        venue : 'Zoom',
        time: '19th April, 2pm - 4pm'

    },
    {
        id: 2,
        name: 'tamasha',
        eventName : 'Tamasha',
        description:'Drama competition for the movie buffs who are tired of troublesome depictions shown in movies, giving them an opportunity to present their perfect story, in the form of a 5-minute-Act!',
        poster:'/images/tamasa_poster.jpeg',
        registration_link: 'http://nss.iitd.ac.in/l/register_Tamasha',
        one_liner : 'A dramatics competition for the movie buffs amongst us who are tired of the sexism, homophobia, transphobia, and other troublesome depictions shown in movies',
        timeline : {
            'Registration Deadline': '9-March-2022',
            'Submission Deadline': '25-March-2022',
            'First Day of Kaizen' : '18-April-2022',
            'Inauguration Ceremony' : '18-April-2022 , 6:45pm - 8:45pm',
            'Event Date' : '19-April-2022, 5pm - 7pm',
        },
        color : 'rgb(26, 26, 90)',
        prizes : {
            "The TAMASHA Award" : {
                'id' : '1',
                'Award' : 'Cash Prize : Rs. 2000 + Coupon : Rs. 2000'
            },
            "People's Choice Award" : {
                'id' : '2',
                'Award' : 'Cash Prize : Rs. 2000 + T-Shirt'
            },
            "Best Social Message Award" : {
                'id' : '3',
                'Award' : 'Cash Prize : Rs. 2000 + Coupon : Rs. 1500',
            },
            "Best Production" : {
                'id' : '4',
                'Award' : 'Rs. 1000'
            },
            "Best Screenplay" : {
                'id' : '5',
                'Award' : 'Rs. 1000',
            },
            "Best Direction" : {
                'id' : '6',
                'Award' : 'Rs. 1000',
            },
            "Best Actor (Team Entry)" : {
                'id' : '7',
                'Award' : 'Rs. 500 + T-shirt',
            },
            "Best Actor (Individual Entry)" : {
                'id' : '8',
                'Award': 'Rs. 500 + T-shirt',
            },
            "Special Mention" : {
                'id' : '9',
                'Award' : 'Coupon : Rs. 1000'
            }
        },
        venue : 'LH 114 and Live Streaming on Zoom',
        time: '19th April, 5pm - 7pm'
    },
    {
        id: 3,
        name: 'bazinga',
        eventName : 'Bazinga',
        description:'A platform for all the young comedians out there to tickle the audience with their greatest comic skills and shoot their punchlines on the social issues around. Be the source of all the guffaws and chuckles to become the best of them all.',
        poster:'/images/bazinga_poster.jpeg',
        registration_link: 'http://nss.iitd.ac.in/l/register_Bazinga',
        one_liner : 'A Social Stand Up Comedy Event for all the young comedians out there.',
        timeline : {
            'Submission Deadline': '18-March-2022',
            'First Day of Kaizen' : '18-April-2022',
            'Inauguration Ceremony' : '18-April-2022, 6:45pm - 8:45pm',
            'Event Date' : '20-April-2022, 5pm - 7pm',
        },
        color : 'yellow', 
        prizes : {
            'Winner' : {
                'id' : 1,
                'Award' : 'Rs. 5500 + Discount Coupons from GeeksforGeeks worth Rs. 2000+ Exciting Goodies'
            },
            '1st Runner Up' : {
                'id' : 2,
                'Award' : 'Rs. 3000 + Discount Coupons from GeeksforGeeks worth Rs. 1500+ Exciting Goodies'
            },
            '2nd Runner Up' : {
                'id' : 3,
                'Award' : 'Rs. 1500 + Discount Coupons from GeeksforGeeks worth Rs. 1000 + Exciting Goodies'
            },
            'Participants' : {
                'id' : '',
                'Award' : 'Participation Certificate'
            }
        },
        venue : 'LH 114 and Live Streaming on Zoom',
        time: '20th April, 5pm - 7pm'
    },
    {
        id: 4,
        name: '404_resolved',
        eventName : '404 Resolved',
        description:'A design sprint hackathon aimed to devise technical scalable solutions for burning social nodus persisting in society.',
        poster:'/images/404_resolved.jpeg',
        registration_link: 'http://nss.iitd.ac.in/l/register_404Resolved',
        one_liner : 'A design-based, sprint where participants compete to find the best technical solution to a social problem',
        timeline : {
            'Registration Deadline': '24-Feb-2022',
            'Submission Deadline Ideation Round' : '06-March-2022',
            'Ideation Round Results' : '12-March-2022',
            'Hackathon Round commences' : '12-March-2022',
            'Hackathon Round Submission' : '15-April-2022',
            'First Day of Kaizen' : '18-April-2022',
            'Inauguration Ceremony' : '18-April-2022, 6:45pm - 8:45pm',
            '404!! Resolved Finale': '20-April-2022, 10am - 12pm',
            
        },
        color : 'rgba(79, 79, 236, 0.527)',
        prizes : {
            'Winner': {
                'id' : 1,
                'Award' : 'Rs. 5,000 cash prize + Discount Coupons from GeeksforGeeks worth Rs. 2000'
            },
            '1st Runner Up' : {
                'id' : 2,
                'Award' : 'Rs. 3,500 cash prize + Discount Coupons from GeeksforGeeks worth Rs. 1500',
            },
            '2nd Runner Up' : {
                'id' : 3,
                'Award' : 'Rs. 1,500 cash prize + Discount Coupons from GeeksforGeeks worth Rs. 1000'
            }
        },
        venue : 'Zoom',
        time: '20th April, 10am - 12pm'
    },
    {
        id: 5,
        name: 'all_rise',
        eventName : 'All Rise',
        description:'It emulates a courtroom and captures the thrill of a real court hearing, to raise awareness on common laws to protect oneself with!',
        poster:'/images/allrise_poster.jpeg',
        registration_link: 'http://nss.iitd.ac.in/l/register_AllRise_Final',
        one_liner : 'A mock courtroom setup over a fictitious case to educate people about basic laws and rights',
        timeline : {
            'Registration Deadline': '18-March-2022',
            'Round-1 Quiz' : '19-March-2022',
            'First Day of Kaizen' : '18-April-2022',
            'Inauguration Ceremony' : '18-April-2022, 6:45pm - 8:45pm',
            'Event Date' : '20-April-2022, 2pm - 4pm',
        },
        color: 'tomato', 
        prizes : {
            'Winner' : {
                'id' : 1,
                'Award' : 'Rs. 6000 + Discount coupons from GeeksforGeeks Rs. 3000 + Exciting Goodies'
            },
            '1st Runner up' : {
                'id' : 2,
                'Award' : 'Rs. 4000 + Discount coupons from GeeksforGeeks Rs. 1500 + Exciting Goodies'
            },
            'Partcipants' : {
                'id' : '',
                'Award' : 'Participation Certificate'
            }
        },
        venue : 'Zoom',
        time: '20th April, 2pm - 4pm'
    },
    {
        id: 6,
        name: 'ingenious_geeks',
        eventName : 'Ingenious Geeks',
        description:'A pan-India virtual science exhibition, providing the students a platform to develop efcient solutions to the problems existing in the society by creating innovative science models',
        poster:'/images/ig_poster.jpeg',
        registration_link: 'http://nss.iitd.ac.in/l/register_IngeniousGeeks',
        one_liner : ' An event to promote individual thinking and innovative ideas among school kids through application-based learning',
        timeline : {
            'Registration Deadline': '12-Feb-2022',
            'Submission Deadline (Ideation Round)' : '24-Feb-2022',
            'Ideation Round Results' : '03-March-2022',
            'Model Making Round (Round 2 commences)' : '04-March-2022',
            'Submission Deadline (Model Making Round)' : '12-April-2022',
            'First Day of Kaizen' : '18-April-2022',
            'Inauguration Ceremony' : '18-April-2022, 6:45pm - 8:45pm',
            'Ingenious Geeks Finale' : '19-April-2022, 3pm - 5pm'

        },
        color: 'palegreen',
        prizes : {
            'Winner' : {
                'id' : 1,
                'Award' : 'Gifts worth Rs. 5,000, GeeksForGeeks Discount Coupon worth Rs. 2,000',
            },
            '1st Runner Up' : {
                'id' : 2,
                'Award' : 'Gifts worth Rs. 3,500, GeeksForGeeks Discount Coupon worth Rs. 1,500'
            },
            '2nd Runner Up' : {
                'id' : 3,
                'Award' : 'Gifts worth Rs. 2,500, GeeksForGeeks Discount Coupon worth Rs. 1,000'
            },
            'Two outstanding ideas' : {
                'id' : '',
                'Award' : 'Gifts worth Rs. 2,000 each'
            }
        },
        speakertit: "OUR ESTEEMED PANEL OF JUDGES"
        ,
        speakers : {
            
            s4 : {
                'id' : 1,
                'name' : 'Prof. Samrat Mukhopadhyay',
                'des' : 'Associate Professor, IIT Delhi',
                'description' : '',
                'image' : '/images/speakers/samrat.png'
            },
            s1 :{
                
                'id' : 2,
                'name' : 'Prof. Seshan Srirangarajan',
                'des' : 'Assistant Professor, IIT Delhi',
                'description' : '',
                'image' : '/images/speakers/seshan.jpeg'
            
            }

        },
        venue : 'Zoom',
        time: '19th April, 10am - 12pm'
    },
    {
        id: 7,
        name: 'aurora',
        eventName : 'Aurora',
        description:"Knowledge and delight converge in Aurora - the inaugural ceremony of Kaizen '22, studded with esteemed guests and making way for change to happen.",        
        poster:'/images/aurora_poster.jpeg',
        registration_link: 'http://nss.iitd.ac.in/l/register_Aurora',
        one_liner: 'Beginning Kaizen with the best of speakers and a fun-filled evening with talented performers, this is the platform to propel social change',
        
        timeline : {
            'Registration Deadline': '13-March-2022',
            'Submission Deadline': '20-March-2021',
            'First Day of Kaizen' : '18-April-2022',
            'Inauguration Ceremony' : '18-April-2022 , 6:45pm - 8:45pm',
            'Event Date' : '19-April-2022, 2pm - 4pm',
        },
        color : 'palegreen',
        prizes : {
            
        },
        speakertit: "Our Esteemed Speakers"
        ,
        speakers : {
            s1 : {
                'id' : 1,
                'name' : 'Mr. Anil Swarup',
                'des' : 'Retired IAS Officer and Author',
                'description' : '',
                'image' : '/images/speakers/anil.jpeg'
            },
            s2 : {
                'id' : 2,
                'name' : 'Prof. Arvind Nema',
                'des' : 'Dean of Student Affairs',
                'description' : '',
                'image' : '/images/speakers/arvind.png'
            },
            s3 : {
                'id' : 3,
                'name' : 'Prof. Ashok Kumar Ganguli',
                'des' : 'Deputy Director (Strategy & Planning), IIT Delhi',
                'description' : '',
                'image' : '/images/speakers/ashok.jpeg'
            },
            s4 : {
                'id' : 4,
                'name' : 'Prof. Samrat Mukhopadhyay',
                'des' : 'Faculty Coordinator, NSS IIT Delhi',
                'description' : '',
                'image' : '/images/speakers/samrat.png'
            }

        },
        venue : 'Seminar Hall, and Live Streaming on Zoom',
        time: '18th April, 6:45pm - 8:45pm'
    }
];

export default eventsData;